import { render, staticRenderFns } from "./AccountRemittance.vue?vue&type=template&id=2b619b3f&scoped=true&"
import script from "./AccountRemittance.vue?vue&type=script&lang=js&"
export * from "./AccountRemittance.vue?vue&type=script&lang=js&"
import style0 from "./AccountRemittance.vue?vue&type=style&index=0&id=2b619b3f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b619b3f",
  null
  
)

export default component.exports